import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { LanguageSwitcherInterface } from 'common/types/entities/LanguageSwitcherInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createLanguageSwitcher(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): LanguageSwitcherInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.LanguageSwitcher,
      parentId,
      masterBlockId,
    ),
    excludedLanguages: [],
    redirectPath: '',
    fontSize: 16,
    color: 'rgba(149, 164, 186, 1)',
  }
}
